import {
  React,
  GridColDef,
  CustomDataGrid,
  Typography,
  Box,
  Divider,
  useNavigate,
  Chip,
} from '../../utils/globalImports';
import { ClientProject } from '../../utils/globalImports';

interface ViewClientProjectsProps {
  clientName: string;
  projectData: ClientProject[];
}

const ViewClientProjects: React.FC<ViewClientProjectsProps> = ({
  projectData,
  clientName,
}) => {

  const navigate = useNavigate();

  const handleRowClick = (params: any) => {
    console.log("Project data", projectData)
    const projectId = params.row.id; // make sure projectId exists
    console.log("projectid", projectId)
    navigate(`/project/edit-projects/${projectId}/general`);
  };
  const columns: GridColDef<(typeof projectData)[number]>[] = [
    { field: 'projectNumber', headerName: 'Project Number', flex: 1, headerAlign: 'center' },
    { field: 'projectName', headerName: 'Project Name', flex: 1, headerAlign: 'center' },
    { field: 'startDate', headerName: 'Start Date', flex: 1, headerAlign: 'center' },
    { field: 'endDate', headerName: 'End Date', flex: 1, headerAlign: 'center' },
    { field: 'status', headerName: 'Status', flex: 1, headerAlign: 'center',
      renderCell: (params) => {
            const value = params.value || '';
            
                const isActive = value === 'Active';
                return (
                    <Box sx={{ display: 'flex', alignItems: 'center', height: '100%' }}>
                        <Chip
                            label={value}
                            size="small"
                            sx={{
                                backgroundColor: isActive ? '#e8f5e9' : '#ffebee',
                                color: isActive ? '#2e7d32' : "#EF4444",
                                fontWeight: '600',
                                fontSize: '11px',
                                border: `1px solid ${isActive ? '#a5d6a7' : '#ef9a9a'}`,
                                height: "24px",
                            }}
                        />
                    </Box>
                );
            }
     },
  ];

  return (
    <Box sx={{ mt: 2 }}>
      <Typography
        sx={{ color: '#1e66ab', fontSize: 20, fontWeight: 500, mb: 2 }}
      >
        {clientName}
      </Typography>
      <Divider sx={{ mb: 2 }} />
      <CustomDataGrid  customMessage='There are no projects to display.' rows={projectData} columns={columns} onRowClick={handleRowClick}/>
    </Box>
  );
};

export default ViewClientProjects;
